import { useQuery } from '@tanstack/react-query'
import { useUserContext } from 'shared/hooks/useUserContext'

import { getAppFolderId } from '../getAppFolderId'

const APP_FOLDER_ID_QUERY_KEY = 'app-folder-id'

/**
 * Resolves the desktop's root app folder id once per authenticated session.
 *
 * The id is read from (and persisted to) user-scoped localStorage by
 * {@link getAppFolderId}, so `setupAppFolder` runs at most once per user and the
 * cached id is reused until logout. `staleTime`/`cacheTime` of `Infinity` keep the
 * value from being refetched on window focus or interval, fixing the redundant
 * `setupAppFolder` calls that previously happened on every files-list refetch.
 */
export const useAppFolderId = () => {
  const { user } = useUserContext()
  const userId = user?.id?.toString()

  return useQuery({
    queryKey: [APP_FOLDER_ID_QUERY_KEY, userId],
    queryFn: getAppFolderId,
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!userId
  })
}
